import { render, staticRenderFns } from "./PageEditModal.vue?vue&type=template&id=7897e226&"
import script from "./PageEditModal.vue?vue&type=script&lang=js&"
export * from "./PageEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports